import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Actions, Aside, Block, Cards, FAQ, Hero, Inner, List, Process, Section, Tool } from "./styled";

const topicByPath = { "/kredyt-hipoteczny-suwalki":"zakup-wtorny", "/kredyt-na-budowe-domu-suwalki":"budowa", "/kredyt-na-mieszkanie-od-dewelopera-suwalki":"zakup-deweloper", "/refinansowanie-kredytu-hipotecznego-suwalki":"refinansowanie", "/kredyt-gotowkowy-suwalki":"gotowkowy", "/finansowanie-firmy-leasing-suwalki":"firma", "/rodzinny-kredyt-mieszkaniowy":"rkm", "/pozyczka-hipoteczna":"pozyczka-hipoteczna" };
const labelByTopic = {"zakup-wtorny":"Porozmawiajmy o Twoim kredycie", "zakup-deweloper":"Omów terminy zakupu", budowa:"Omów kosztorys i transze", refinansowanie:"Porównajmy Twój obecny kredyt", gotowkowy:"Porównaj możliwości finansowania", firma:"Omów finansowanie swojej firmy", rkm:"Sprawdźmy Twój wkład i możliwości", "pozyczka-hipoteczna":"Porównaj możliwości finansowania"};
const ServicePage = ({ service }) => {
  const {hash} = useLocation();
  useEffect(() => {
    if (!hash) return;
    const timer=window.setTimeout(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({block:"start",behavior:window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto":"smooth"}),120);
    return () => window.clearTimeout(timer);
  }, [hash, service.path]);
  const topic = service.topic || topicByPath[service.path] || "inne";
  const contactHref = `/?source=formularz&topic=${encodeURIComponent(topic)}`;
  const contactLabel = service.contactLabel || labelByTopic[topic] || "Poproś o kontakt";
  return (
  <main>
    <Hero>
      <Inner>
        <p>{service.eyebrow}</p>
        <h1>{service.title}</h1>
        <div>{service.lead}</div>
        <p className="local-note">Biuro w Suwałkach. Obsługa online w całej Polsce.</p>
        <Actions><Link to={contactHref} data-contact-cta>{contactLabel}</Link><a href="#jak-to-dziala">Zobacz kolejne kroki ↓</a></Actions>
      </Inner>
    </Hero>

    <Section>
      <Inner>
        <Block><span>Prostym językiem</span><h2>Co to właściwie oznacza?</h2><p>{service.definition}</p></Block>
      </Inner>
    </Section>

    <Section $muted id="jak-to-dziala">
      <Inner>
        <Block><span>Proces</span><h2>Jak wygląda współpraca krok po kroku?</h2></Block>
        <Process>{service.steps.map((step,index)=><li key={step}><b>{String(index+1).padStart(2,"0")}</b><strong>{step}</strong></li>)}</Process>
      </Inner>
    </Section>

    <Section>
      <Inner>
        <Cards>
          <Aside><span>Dokumenty</span><h2>Co zwykle warto przygotować?</h2><List>{service.documents.map(item=><li key={item}>{item}</li>)}</List></Aside>
          <Aside $accent><span>Uwaga</span><h2>Co najczęściej komplikuje proces?</h2><List>{service.problems.map(item=><li key={item}>{item}</li>)}</List></Aside>
        </Cards>
        {service.legalNote && <p className="service-note">{service.legalNote}</p>}
      </Inner>
    </Section>

    {service.tools.length > 0 && <Section $green><Inner><Block><span>Bezpłatne narzędzia</span><h2>Najpierw policz i przygotuj dane</h2><p>Wynik kalkulatora jest orientacyjny. Pomaga przygotować pytania i warianty do dalszej analizy, ale nie stanowi decyzji kredytowej ani oferty banku.</p></Block><Actions>{service.tools.map(tool=><Tool key={tool.href} href={tool.href} target="_blank" rel="noopener noreferrer">{tool.label} →</Tool>)}</Actions></Inner></Section>}

    {service.protection && <Section><Inner><Block><span>Obszary ochrony</span><h2>Co chcesz zabezpieczyć?</h2></Block>{service.protection.map(item => <Aside key={item.id} id={item.id} style={{scrollMarginTop:110,marginTop:20}}><h2>{item.title}</h2><p>{item.text}</p><List>{item.checks.map(check=><li key={check}>{check}</li>)}</List><Actions><Link to={contactHref} data-contact-cta>Porozmawiaj o ochronie rodziny</Link></Actions></Aside>)}</Inner></Section>}
    <Section $muted>
      <Inner><Block><span>Najczęstsze pytania</span><h2>O co pytają klienci?</h2></Block><FAQ>{service.faq.map(([question,answer])=><details key={question}><summary>{question}<span>+</span></summary><p>{answer}</p></details>)}</FAQ></Inner>
    </Section>

    <Section><Inner><Block><span>Następny krok</span><h2>Ustalmy, co warto zrobić w Twojej sytuacji</h2><p>Powiedz, co planujesz i na jakim jesteś etapie. Omówimy Twój cel, dostępne informacje oraz dokumenty potrzebne do dalszej analizy. Nie musisz mieć jeszcze kompletnej dokumentacji.</p><Actions><Link to={contactHref} data-contact-cta>{contactLabel}</Link><a href="tel:+48783737050">Zadzwoń: 783 737 050</a></Actions></Block></Inner></Section>
  </main>
);
};

export default ServicePage;
